/*
 *
 * ActionShelfRibbonSection
 *
 */

import React from 'react';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { useDispatch } from 'react-redux';
import Img from 'components/Img';
import upShelf from 'assets/images/ribbons/shelvesRibbon/upShelf.svg';
import downShelf from 'assets/images/ribbons/shelvesRibbon/downShelf.svg';
import {
  addShelf,
  removeShelfRequest,
  switchShelfPosition,
} from 'containers/Configurator/actions/furniture';
import styled from 'styled-components/macro';
import { FiTrash, FiCopy } from 'react-icons/fi';
import useMedia from 'use-media';

interface Props {
  shelf: Shelf;
}

function ActionShelfRibbonSection({ shelf }: Props) {
  const dispatch = useDispatch();

  const isMobile = useMedia({ maxWidth: 1023 });

  if (isMobile) {
    return (
      <div className="flex flex-row">
        <ActionBtn
          onClick={() => {
            dispatch(switchShelfPosition(shelf.level, 1));
          }}
        >
          <StyledArrangeImg src={upShelf} alt="shelf up" />
        </ActionBtn>
        <ActionBtn
          onClick={() => {
            dispatch(switchShelfPosition(shelf.level, -1));
          }}
        >
          <StyledArrangeImg src={downShelf} alt="shelf down" />
        </ActionBtn>

        <ActionBtn
          onClick={() => {
            dispatch(addShelf(shelf.level));
          }}
        >
          <FiCopy className="h-10 w-10 mb-2 text-gray-700" />
        </ActionBtn>
        <ActionBtn
          onClick={() => {
            dispatch(removeShelfRequest(shelf.level));
          }}
        >
          <FiTrash className="h-10 w-10 mb-2 text-red-dark" />
        </ActionBtn>
      </div>
    );
  }

  return (
    <div className="flex flex-col mt-2">
      <div className="flex -mt-1">
        <ActionBtn
          onClick={() => {
            dispatch(switchShelfPosition(shelf.level, 1));
          }}
        >
          <StyledArrangeImg src={upShelf} alt="shelf up" />
        </ActionBtn>
        <ActionBtn
          onClick={() => {
            dispatch(addShelf(shelf.level));
          }}
        >
          <FiCopy className="h-6 w-6 mb-2 text-gray-700" />
        </ActionBtn>
      </div>
      <div className="flex lg:-mt-1">
        <ActionBtn
          onClick={() => {
            dispatch(switchShelfPosition(shelf.level, -1));
          }}
        >
          <StyledArrangeImg src={downShelf} alt="shelf down" />
        </ActionBtn>
        <ActionBtn
          onClick={() => {
            dispatch(removeShelfRequest(shelf.level));
          }}
        >
          <FiTrash className="h-6 w-6 mb-2 text-red-dark" />
        </ActionBtn>
      </div>
    </div>
  );
}

export default ActionShelfRibbonSection;

const StyledArrangeImg = styled(Img)`
  //h-10 w-10 mb-2 text-gray-700
  height: 2.5rem;
  width: 2.5rem;
  color: ${p => p.theme.gray700};

  @media (min-width: 1024px) {
    height: 1.5rem;
    width: 1.5rem;
  }
`;

const ActionBtn = styled.button`
  margin: 0.25rem 0.75rem;
  height: 2.5rem;
  width: 2.5rem;

  @media (min-width: 1024px) {
    height: 1.5rem;
    width: 1.5rem;
    margin: 0.25rem 0.25rem 0.75rem 0.25rem;
  }
`;
